import { postLogin, logout, getInfo } from '@/api/login'
import { noreadNotice } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth'

const tokenInfo = getToken();
const user = {
  state: {
    token: tokenInfo ? JSON.parse(tokenInfo).token || '' : '',
    name: '',
    avatar: '',
    roles: '',
    noticeCount: 0,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_NOTICE_COUNT(state, count) {
      state.noticeCount = Math.max(count, 0);
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()

      return new Promise((resolve, reject) => {
        postLogin(username, userInfo.password, userInfo.smscode).then(response => {
          const data = response.returnValue;
          setToken({userId:data.id})
          commit('SET_TOKEN', data.token)
          window.localStorage.setItem('ownSite',data.ownSite);
        //   commit('SET_OWNSITE', data.ownSite)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {

      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.returnValue;
          // debugger;
          commit('SET_ROLES', data.accountType+"")
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', '')
        removeToken()
      // return new Promise((resolve, reject) => {
      //   logout(state.token).then(() => {
      //     commit('SET_TOKEN', '')
      //     commit('SET_ROLES', [])
      //     removeToken()
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 获取消息通知的数量
    GetNoticeCount({ commit }) {
      return new Promise((resolve, reject) => {
        noreadNotice().then(res => {
          commit('SET_NOTICE_COUNT', res || 0);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js